export default __webpack_public_path__ + "static/media/Whatsapp.da7db341.svg";